import BootstrapSwitchButton from 'bootstrap-switch-button-react';
import React from 'react';
import { Row, Col, FormGroup, Card, Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import CustomDatePicker from '../../../../Components/Utility/DatePicker/DatePicker';
import '../Potemplate.css';

function PurchaseOrderDetail({ data, i, fromForm, onChangeForData }) {
  const local = JSON.parse(localStorage?.getItem('loggedInUserInfo'));
  const { t } = useTranslation('common');

  const hasLogo = () => {
    return local?.companyLogo ? `https://${process.env.REACT_APP_BUCKET_NAME}.s3.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${local?.companyLogo}` : '';
  };

  const handlings3Image = () => {
    return local?.companyLogo?.includes('s3.eu-west-2') ? local?.companyLogo : hasLogo();
  };

  const handleOriginalSavedImage = () => {
    return data?.originalImg?.includes('base64') ? data?.originalImg : handlings3Image();
  };
  const handleOriginalImage = () => {
    return data?.originalImg ? `${data?.originalImg}` : handleOriginalSavedImage();
  };

  const ifEditedImage = () => {
    return data?.image ? `${data?.image}` : handleOriginalImage();
  };

  return (
    <Container fluid className="position-relative p-0">
      <Row key={`${data?.label}_${i}`}>
        <Col lg={12}>
          <Card className="listing-card pt-1">
            <Card.Body>
              <Row>
                <Col lg={6} className="company-logo-block d-flex">
                  <figure>
                    <img src={data?.image?.includes('base64') ? data?.image : ifEditedImage()} alt="" />
                  </figure>
                  {fromForm && (
                    <button
                      className="btn align-items-center justify-content-center"
                      type="button"
                      title={t('PO_TEMPLATES.PO_DETAILS.PURCHASE_ORDER_DETAIL.UPLOAD')}
                      aria-label={t('PO_TEMPLATES.PO_DETAILS.PURCHASE_ORDER_DETAIL.UPLOAD')}
                      onClick={(e) => onChangeForData(e, 'uploadImage')}
                    >
                      <span className="icon-upload" />
                    </button>
                  )}
                </Col>
                <Col lg={6}>
                  {fromForm && (
                    <div className="d-flex">
                      <div className="custom-switch-on-off po-template  ml-auto">
                        <BootstrapSwitchButton
                          checked={data?.isActive}
                          onlabel="Active"
                          offlabel="InActive"
                          onChange={(e) => onChangeForData(e, 'PO_Template_Button')}
                        />
                      </div>
                    </div>
                  )}
                  <Row>
                    <Col lg={12}>
                      <div className="input-group form-floating-label-po fixed-label">
                        <label className="asterisk-req f-14">{t('PO_TEMPLATES.PO_DETAILS.PURCHASE_ORDER_DETAIL.TEMPLATE_NAME')}</label>
                        <input
                          type="text"
                          name="Template Name"
                          placeholder={t('PO_TEMPLATES.PO_DETAILS.PURCHASE_ORDER_DETAIL.TEMPLATE_NAME')}
                          value={data?.name}
                          className="form-control f-14"
                          onChange={(e) => onChangeForData(e, 'template_name')}
                          disabled={!fromForm}
                        />
                      </div>
                      {data?.nameErr && !data?.name && (
                        <span className="error-message">{t('PO_TEMPLATES.PO_DETAILS.PURCHASE_ORDER_DETAIL.TEMPLATE_NAME_REQUIRED')}</span>
                      )}
                    </Col>
                    <Col lg={6} className="mt-2">
                      <div className="input-group form-floating-label-po fixed-label">
                        <label className="asterisk-req f-14">{t('PO_TEMPLATES.PO_DETAILS.PURCHASE_ORDER_DETAIL.PURCHASE_ORDER_NUMBER')}</label>
                        <input
                          type="text"
                          placeholder={t('PO_TEMPLATES.PO_DETAILS.PURCHASE_ORDER_DETAIL.PURCHASE_ORDER_NUMBER')}
                          className="form-control f-14"
                          disabled
                          readOnly
                        />
                      </div>
                    </Col>
                    <Col lg={6} className="mt-2">
                      <FormGroup>
                        <label className="text-label mb-0 asterisk-req f-14">{t('PO_TEMPLATES.PO_DETAILS.PURCHASE_ORDER_DETAIL.PURCHASE_ORDER_DATE')}</label>
                        <div className="date">
                          <div className="input-button-container">
                            <CustomDatePicker
                              dateFormat="dd/MMM/yyyy"
                              name="selectedActualApproveByDate"
                              popperPlace="top-end"
                              placeholder={t('PO_TEMPLATES.PO_DETAILS.PURCHASE_ORDER_DETAIL.RECENT_DATE')}
                              disable
                              readOnly
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default PurchaseOrderDetail;
